<form [formGroup]="personForm" class="row g-3">
  <div *ngIf="showTypePerson">
    <div class="row mb-3">
      <div class="col-12">
        <div class="form-group">
          <label for="tipoDePersona" class="form-label text3-tipografia-govco"
            >{{ comunText['tipo-persona'] }} {{ personTypeLabel }} </label
          ><span class="text-danger"> *</span>
          <select
            formControlName="tipoDePersona"
            class="form-select"
            type="text"
            id="tipoDePersona"
            (change)="onTypePersonChange($event)"
            [ngClass]="{
              'is-invalid':
                personForm.get('tipoDePersona')?.invalid &&
                personForm.get('tipoDePersona')?.touched,
              autocompleted:
                personForm.get('tipoDePersona')?.value &&
                personForm.get('tipoDePersona')?.pristine,
            }">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option *ngFor="let item of tipoDePersonaList" [value]="item.Id">
              {{ item.Tipo_Persona }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('tipoDePersona')?.invalid &&
              personForm.get('tipoDePersona')?.touched
            ">
            <div
              *ngIf="personForm.get('tipoDePersona')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['tipo-persona-required'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isNaturalPerson !== undefined || !showTypePerson">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label for="email" class="form-label text3-tipografia-govco"
            >{{ comunText['email'] }} </label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="email"
            formControlName="email"
            placeholder="correo@mail.com"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('email')?.invalid &&
                personForm.get('email')?.touched,
              autocompleted:
                personForm.get('email')?.value &&
                personForm.get('email')?.pristine,
            }"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('email')?.invalid &&
              personForm.get('email')?.touched
            ">
            <div
              *ngIf="personForm.get('email')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['correo-required'] }}
            </div>
            <div
              *ngIf="personForm.get('email')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['email-pattern'] }}
            </div>
            <!-- <div
              *ngIf="personForm.get('email')?.errors?.['domainRequired']"
              class="invalid-feedback">
              El correo electrónico debe contener un dominio.
            </div> -->
            <div
              *ngIf="personForm.get('email')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{ isDimar ? comunText['email-dimar-maxlength']: comunText['email-maxlength'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div *ngIf="isNaturalPerson" class="col-md-6">
        <div class="form-group">
          <label for="primerNombre" class="form-label text3-tipografia-govco"
            >{{ comunText['primer-nombre'] }} </label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="primerNombrePNatural"
            formControlName="primerNombre"
            maxlength="25"
            [placeholder]="comunText['primer-nombre']"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('primerNombre')?.invalid &&
                personForm.get('primerNombre')?.touched,
              autocompleted:
                personForm.get('primerNombre')?.value &&
                personForm.get('primerNombre')?.pristine,
            }"
            (focus)="onFocus('primerNombre')"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('primerNombre')?.invalid &&
              personForm.get('primerNombre')?.touched
            ">
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['primer-nombre-required'] }}
            </div>
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['nombre-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['nombre-minlength'] }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isNaturalPerson" class="col-md-12">
        <div class="form-group">
          <label for="primerNombre" class="form-label text3-tipografia-govco">{{
            comunText['razon-social']
          }}</label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="primerNombre"
            formControlName="primerNombre"
            maxlength="100"
            [placeholder]="comunText['razon-social']"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('primerNombre')?.invalid &&
                personForm.get('primerNombre')?.touched,
              autocompleted:
                personForm.get('primerNombre')?.value &&
                personForm.get('primerNombre')?.pristine,
            }"
            (focus)="onFocus('primerNombre')"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('primerNombre')?.invalid &&
              personForm.get('primerNombre')?.touched
            ">
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['razon-social-required'] }}
            </div>
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['razon-social-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('primerNombre')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['razon-social-minlength'] }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isNaturalPerson" class="col-md-6">
        <div class="form-group">
          <label
            for="segundoNombre"
            class="form-label text3-tipografia-govco"
            >{{ comunText['segundo-nombre'] }}</label
          >
          <input
            type="text"
            class="form-control"
            id="segundoNombre"
            formControlName="segundoNombre"
            [placeholder]="comunText['segundo-nombre']"
            maxlength="25"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('segundoNombre')?.invalid &&
                personForm.get('segundoNombre')?.touched,
              autocompleted:
                personForm.get('segundoNombre')?.value &&
                personForm.get('segundoNombre')?.pristine,
            }"
            (focus)="onFocus('segundoNombre')"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('segundoNombre')?.invalid &&
              personForm.get('segundoNombre')?.touched
            ">
            <div
              *ngIf="personForm.get('segundoNombre')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['nombre-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('segundoNombre')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['nombre-minlength'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isNaturalPerson" class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="primerApellido" class="form-label text3-tipografia-govco"
            >{{ comunText['primer-apellido'] }} </label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="primerApellido"
            formControlName="primerApellido"
            [placeholder]="comunText['primer-apellido']"
            maxlength="25"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('primerApellido')?.invalid &&
                personForm.get('primerApellido')?.touched,
              autocompleted:
                personForm.get('primerApellido')?.value &&
                personForm.get('primerApellido')?.pristine,
            }"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('primerApellido')?.invalid &&
              personForm.get('primerApellido')?.touched
            ">
            <div
              *ngIf="personForm.get('primerApellido')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['primer-apellido-required'] }}
            </div>
            <div
              *ngIf="personForm.get('primerApellido')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['apellido-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('primerApellido')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['apellido-minlength'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            for="segundoApellido"
            class="form-label text3-tipografia-govco"
            >{{ comunText['segundo-apellido'] }}</label
          >
          <input
            type="text"
            class="form-control"
            id="segundoApellido"
            formControlName="segundoApellido"
            [placeholder]="comunText['segundo-apellido']"
            maxlength="25"
            appUppercase
            [ngClass]="{
              'is-invalid':
                personForm.get('segundoApellido')?.invalid &&
                personForm.get('segundoApellido')?.touched,
              autocompleted:
                personForm.get('segundoApellido')?.value &&
                personForm.get('segundoApellido')?.pristine,
            }"
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('segundoApellido')?.invalid &&
              personForm.get('segundoApellido')?.touched
            ">
            <div
              *ngIf="personForm.get('segundoApellido')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['apellido-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('segundoApellido')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['apellido-minlength'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div *ngIf="isNaturalPerson" class="col-md-6">
        <div class="form-group">
          <label for="tipoDocumento" class="form-label text3-tipografia-govco"
            >{{ comunText['tipo-documento'] }} </label
          ><span class="text-danger"> *</span>
          <select
            *ngIf="isApoderado == false && isParteInteresada == false"
            formControlName="tipoDocumento"
            class="form-select"
            type="text"
            id="tipoDocumento"
            (change)="validarEsIndocumentado($event)"
            [ngClass]="{
              'is-invalid':
                personForm.get('tipoDocumento')?.invalid &&
                personForm.get('tipoDocumento')?.touched,
              autocompleted:
                personForm.get('tipoDocumento')?.value &&
                personForm.get('tipoDocumento')?.pristine,
            }">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option *ngFor="let item of documentTypeList" [value]="item.Id">
              {{ item.Descripcion }}
            </option>
          </select>
          <select
            *ngIf="isApoderado"
            formControlName="tipoDocumento"
            class="form-select"
            type="text"
            id="tipoDocumentoApoderado"
            [ngClass]="{
              'is-invalid':
                personForm.get('tipoDocumento')?.invalid &&
                personForm.get('tipoDocumento')?.touched,
              autocompleted:
                personForm.get('tipoDocumento')?.value &&
                personForm.get('tipoDocumento')?.pristine,
            }">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option
              *ngFor="let item of documentTypeListApoderado"
              [value]="item.Id">
              {{ item.Descripcion }}
            </option>
          </select>
          <select
            *ngIf="isParteInteresada"
            formControlName="tipoDocumento"
            class="form-select"
            type="text"
            (change)="validarEsIndocumentado($event)"
            id="tipoDocumentoParteInteresada"
            [ngClass]="{
              'is-invalid':
                personForm.get('tipoDocumento')?.invalid &&
                personForm.get('tipoDocumento')?.touched,
              autocompleted:
                personForm.get('tipoDocumento')?.value &&
                personForm.get('tipoDocumento')?.pristine,
            }">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option
              *ngFor="let item of documentTypeListInteresada"
              [value]="item.Id">
              {{ item.Descripcion }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('tipoDocumento')?.invalid &&
              personForm.get('tipoDocumento')?.touched
            ">
            <div
              *ngIf="personForm.get('tipoDocumento')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['tipo-documento-required'] }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isNaturalPerson" class="col-md-6">
        <div class="form-group">
          <label for="tipoDocumento" class="form-label text3-tipografia-govco"
            >{{ comunText['tipo-documento'] }} </label
          ><span class="text-danger"> *</span>
          <select
            formControlName="tipoDocumento"
            class="form-select"
            type="text"
            id="tipoDocumentoJuridica"
            [ngClass]="{
              'is-invalid':
                personForm.get('tipoDocumento')?.invalid &&
                personForm.get('tipoDocumento')?.touched,
              autocompleted: isAutocompleted('tipoDocumento'),
            }"
            (focus)="onFocus('tipoDocumento')">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option
              *ngFor="let item of documentTypeListJuridica"
              [value]="item.Id">
              {{ item.Descripcion }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('tipoDocumento')?.invalid &&
              personForm.get('tipoDocumento')?.touched
            ">
            <div
              *ngIf="personForm.get('tipoDocumento')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['tipo-documento-required'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!esTipoDocIndocumentado">
        <div class="form-group">
          <label for="identificacion" class="form-label text3-tipografia-govco"
            >{{
              isNaturalPerson ? comunText['numero-documento'] : comunText['nit']
            }} </label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="identificacion"
            formControlName="identificacion"
            [placeholder]="comunText['numero-documento']"
            [ngClass]="{
              'is-invalid':
                personForm.get('identificacion')?.invalid &&
                personForm.get('identificacion')?.touched,
              autocompleted: isAutocompleted('identificacion'),
            }"
            (focus)="onFocus('identificacion')"
            (change)="
              updateIdentificationValidators(
                personForm.get('tipoDocumento')?.value
              )
            "
            autocomplete="off"/>
          <div
            *ngIf="
              personForm.get('identificacion')?.invalid &&
              personForm.get('identificacion')?.touched
            ">
            <div
              *ngIf="personForm.get('identificacion')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['numero-documento-required'] }}
            </div>
            <div
              *ngIf="personForm.get('identificacion')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ validationMessageMin }}
            </div>
            <div
              *ngIf="personForm.get('identificacion')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{ validationMessage }}
            </div>
            <div
              *ngIf="personForm.get('identificacion')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ validationMessagePattern }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="pais" class="form-label text3-tipografia-govco"
            >{{ comunText['country'] }} {{showAditionalText ? aditionalText : ''}}</label
          ><span class="text-danger"> *</span>
          <select
            formControlName="pais"
            class="form-select"
            type="text"
            id="pais"
            (change)="onChangeCountry($event)"
            [ngClass]="{
              'is-invalid':
                personForm.get('pais')?.invalid &&
                personForm.get('pais')?.touched,
              autocompleted: isAutocompleted('pais'),
            }"
            (focus)="onFocus('pais')">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option *ngFor="let item of countries" [value]="item.Id">
              {{ item.Nombre }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('pais')?.invalid && personForm.get('pais')?.touched
            ">
            <div
              *ngIf="personForm.get('pais')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['country-required'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!hideDepartment">
        <div class="form-group">
          <label for="departmento" class="form-label text3-tipografia-govco"
            >{{ comunText['departament'] }} {{showAditionalText ? aditionalText : ''}}</label
          ><span class="text-danger"> *</span>
          <select
            formControlName="departmento"
            class="form-select"
            type="text"
            id="departmento"
            (change)="onChangeDepartment($event)"
            [ngClass]="{
              'is-invalid':
                personForm.get('departmento')?.invalid &&
                personForm.get('departmento')?.touched,
              autocompleted: isAutocompleted('departmento'),
            }"
            (focus)="onFocus('departmento')">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option *ngFor="let item of departments" [value]="item.Id">
              {{ item.Nombre }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('departmento')?.invalid &&
              personForm.get('departmento')?.touched
            ">
            <div
              *ngIf="personForm.get('departmento')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['departament-required'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!hideMunicipality">
        <div class="form-group">
          <label for="municipio" class="form-label text3-tipografia-govco"
            >{{ comunText['municipality'] }} {{showAditionalText ? aditionalText : ''}}</label
          ><span class="text-danger"> *</span>
          <select
            formControlName="municipio"
            class="form-select"
            type="text"
            id="municipio"
            [ngClass]="{
              'is-invalid':
                personForm.get('municipio')?.invalid &&
                personForm.get('municipio')?.touched,
              autocompleted: isAutocompleted('municipio'),
            }"
            (focus)="onFocus('municipio')">
            <option disabled selected value="">
              {{ personaText['seleccione-opcion'] }}
            </option>
            <option *ngFor="let item of municipalities" [value]="item.Id">
              {{ item.Nombre }}
            </option>
          </select>
          <div
            *ngIf="
              personForm.get('municipio')?.invalid &&
              personForm.get('municipio')?.touched
            ">
            <div
              *ngIf="personForm.get('municipio')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['municipality-required'] }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="hideDepartment">
        <div class="form-group">
          <label for="departmento" class="form-label text3-tipografia-govco"
          >{{comunText['departament']}} {{showAditionalText ? aditionalText : ''}}</label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="otroDepartamento"
            formControlName="otroDepartamento"
            [ngClass]="{
              'is-invalid':
                personForm.get('otroDepartamento')?.invalid &&
                personForm.get('otroDepartamento')?.touched,
              'autocompleted':
                isAutocompleted('otroDepartamento'),
            }"
            (focus)="onFocus('otroDepartamento')"
            autocomplete="off"
            appUppercase
          />
          <div
            *ngIf="
              personForm.get('otroDepartamento')?.invalid &&
              personForm.get('otroDepartamento')?.touched
            ">
            <div
              *ngIf="personForm.get('otroDepartamento')?.errors?.['required']"
              class="invalid-feedback">
              {{comunText['departament-required']}}
            </div>
            <div
              *ngIf="personForm.get('otroDepartamento')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{comunText['department-maxlength']}}
            </div>
            <div
              *ngIf="personForm.get('otroDepartamento')?.errors?.['pattern']"
              class="invalid-feedback">
              {{comunText['department-pattern']}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="hideMunicipality">
        <div class="form-group">
          <label for="otroMunicipio" class="form-label text3-tipografia-govco"
          >{{comunText['municipality']}} {{showAditionalText ? aditionalText : ''}}</label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="otroMunicipio"
            formControlName="otroMunicipio"
            [ngClass]="{
              'is-invalid':
                personForm.get('otroMunicipio')?.invalid &&
                personForm.get('otroMunicipio')?.touched,
              'autocompleted':
                isAutocompleted('otroMunicipio'),
            }"
            (focus)="onFocus('otroMunicipio')"
            autocomplete="off"
            appUppercase
          />
          <div
            *ngIf="
              personForm.get('otroMunicipio')?.invalid &&
              personForm.get('otroMunicipio')?.touched
            ">
            <div
              *ngIf="personForm.get('otroMunicipio')?.errors?.['required']"
              class="invalid-feedback">
              {{comunText['municipality-required']}}
            </div>
            <div
              *ngIf="personForm.get('otroMunicipio')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{comunText['municipality-maxlength']}}
            </div>
            <div
              *ngIf="personForm.get('otroMunicipio')?.errors?.['pattern']"
              class="invalid-feedback">
              {{comunText['municipality-pattern']}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="direccion" class="form-label text3-tipografia-govco"
            >{{ comunText['direccion-notificacion-judicial'] }} </label
          ><span class="text-danger"> *</span>
          <div class="d-flex align-items-center">
            <input
              type="text"
              class="form-control"
              id="direccion"
              formControlName="direccion"
              [placeholder]="
                comunText['direccion-notificacion-judicial-placeholder']
              "
              appUppercase
              [ngClass]="{
                'is-invalid': personForm.get('direccion')?.invalid && (personForm.get('direccion')?.touched || personForm.get('direccion')?.dirty) && !isAutocompleted('direccion'),
                'autocompleted': isAutocompleted('direccion')
              }"
              (focus)="onFocus('direccion')"
              autocomplete="off"
              maxlength="40"/>
          </div>
          <div
            *ngIf="personForm.get('direccion')?.invalid && personForm.get('direccion')?.touched && !isAutocompleted('direccion')"
            >
            <div
              *ngIf="personForm.get('direccion')?.errors?.['required']"
              class="invalid-feedback">
              {{ comunText['direccion-notificacion-judicial-required'] }}
            </div>
            <div
              *ngIf="personForm.get('direccion')?.errors?.['pattern']"
              class="invalid-feedback">
              {{ comunText['direccion-notificacion-judicial-pattern'] }}
            </div>
            <div
              *ngIf="personForm.get('direccion')?.errors?.['minlength']"
              class="invalid-feedback">
              {{ comunText['direccion-notificacion-judicial-minlength'] }}
            </div>
            <div
              *ngIf="personForm.get('direccion')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{ comunText['direccion-notificacion-judicial-maxlength'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
